// author：jiana
// time:2024-06-12
// desc:本页面为方便快速构建vue文件模板基础页面搭建，在次基础上快速搭建

<template>
	<div class="feed">
		<!-- 顶部导航 -->
		<menuNav :bgClass="bgClass"></menuNav>
		<!-- 第一屏 -->
		<div class="screenSize">
			<el-carousel height="80vh" arrow='never' indicator-position="none">
				<el-carousel-item>
					<img src="../../assets/imgs/siwei1.png" alt="" />
				</el-carousel-item>
			</el-carousel>
		</div>
		<!-- 第二屏 -->
		<div class="screenSizeOne">
			<el-carousel height="80vh" arrow='never' indicator-position="none">
				<el-carousel-item>
					<img src="../../assets/imgs/siwei2.png" alt="" />
				</el-carousel-item>
			</el-carousel>
		</div>
		<!-- 第二屏 -->
		<div class="screenSizeOne">
			<el-carousel height="80vh" arrow='never' indicator-position="none">
				<el-carousel-item>
					<img src="../../assets/imgs/siwei3.png" alt="" />
				</el-carousel-item>
			</el-carousel>
		</div>
		<!-- 底部 -->
		<footerIndex></footerIndex>
	</div>
</template>

<script>
import footerIndex from '../../components/footer/footerIndex.vue'
import menuNav  from '../../components/nav/menuNav.vue'
export default {
	name: 'feed',
	components: {
		footerIndex,menuNav
	},
	props:{
		
	},
	data() {
		return {
			bgClass:true,
		}
	},
	computed: {

	},
	methods: {
	},

	mounted() {
	},

	watch: {

	}
}
</script>

<style lang="less" scoped>
body {
    margin: 0; /* 如果页面出现垂直滚动条，则加入此行CSS以消除之 */
}
.box1200{
	width: 1200PX;
	margin: 0 auto;
}
.feed{
	.screenSize{
		width: 100%;
		// height: 85vh;
		padding-top: 7vh;
		img{
			width: 100%;
			height: 100%;
		}
		// overflow: hidden;
	}
	.screenSizeOne{
		width: 100%;
		img{
			width: 100%;
			height: 100%;
		}
	}
}
</style>
